import { useState, useRef } from 'react';

const DEFAULT_WIDTH = 200;

type UseResizeParams = {
  defaultWidth?: number;
};

type Size = {
  width: number;
};

export const useResize = ({ defaultWidth = DEFAULT_WIDTH }: UseResizeParams) => {
  const [size, setSize] = useState<Size>({ width: 0 });
  const isResizing = useRef(false);

  const handleMouseDown = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    isResizing.current = true;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!isResizing.current) {
      return;
    }

    setSize((prevSize) => ({
      width: Math.max(defaultWidth, prevSize.width + e.movementX),
    }));
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  const defaultSize: Size = {
    width: size.width || defaultWidth,
  };

  return { handleMouseDown, size: defaultSize };
};
